import { exact, arrayOf, bool, string, object } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import MessageBox from 'yoda-core-components/lib/components/MessageBox/next';
import MessageBoxOld from 'yoda-core-components/lib/components/MessageBox/MessageBox';
import ProductAttributes from 'yoda-checkout-components/lib/components/ProductAttributes/ProductAttributes';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';

export const OOSDiscontinuedMessage = ({
    notAvailableProducts,
    discontinuedOOSMessage: { TITLE, BODY },
    enableOOSDiscontinuedMessageWithItemHyperLink,
    b2bAgentMarketPlaceItemProducts,
    b2bAgentMarketPlaceItemMessage: { TITLE: B2B_TITLE, BODY: B2B_BODY },
    isB2BAgentMarketPlaceItemPresent,
    fromB2bAgentMarketPlace,
    fromOOS,
}) => {
    const outOfStockOrDiscontinuedItemPresent = notAvailableProducts.length > 0;

    /* istanbul ignore next */
    const scrollToItem = (cartItemId) => {
        const match = document.getElementById(cartItemId);
        if (match && window) {
            const rect = match.getBoundingClientRect();
            const anchorOffset = window.pageYOffset + rect.top - 55;
            window.scrollTo(0, anchorOffset);
        }
    };

    const messageTypeConfigurations = {
        OOS_DISCONTINUE: {
            messageType: 'info',
            title: TITLE,
            body: BODY,
            products: notAvailableProducts,
            automationId: 'at-discontinued-oos',
        },
        B2B_AGENT_MKT: {
            messageType: 'error',
            title: B2B_TITLE,
            body: B2B_BODY,
            products: b2bAgentMarketPlaceItemProducts,
            automationId: 'at-b2bAgent-mktItem',
        },
    };

    const renderMessage = (fromRender) => {
        const config = messageTypeConfigurations[fromRender];
        const itemRenderer = ({ name, cartItemId, attributes }) => {
            const productAttributes = attributes && (
                <>
                    &nbsp;-&nbsp;{' '}
                    <ProductAttributes
                        attributes={attributes}
                        splitBy=" / "
                        className={dt(['text-black', 'inline', 'lg:text-base', 'lg:!leading-6'])}
                        excludeVDataFormatting
                    />
                </>
            );

            return (
                <li className={dt(['mb-2', 'text-base', 'leading-6'])}>
                    <button
                        type="button"
                        onClick={() => scrollToItem(cartItemId)}
                        className={dt(['text-black', 'underline', 'text-left'])}
                    >
                        {name}
                        {productAttributes}
                    </button>
                </li>
            );
        };

        return enableOOSDiscontinuedMessageWithItemHyperLink ? (
            <MessageBox
                messageType={config.messageType}
                automationId={`${config.automationId}-detail-error`}
                message={config.body}
                showMessage
                className={dt(['mb-6', 'mt-2', 'p-3'])}
                listProps={{
                    automationId: `${config.automationId}-msg-block`,
                    children: config.products,
                    listType: 'disc',
                    itemRenderer,
                }}
            />
        ) : (
            <MessageBoxOld
                type="error"
                level="section"
                hasClose={false}
                className={dt(['mx-3', 'p-3'])}
                title={config.title}
                automationId={`${config.automationId}-detail-error`}
            >
                <div data-automation-id={`${config.automationId}-msg-block`}>{config.body}</div>
            </MessageBoxOld>
        );
    };

    if (fromOOS && outOfStockOrDiscontinuedItemPresent) {
        return renderMessage('OOS_DISCONTINUE');
    }
    /** MCYODA-31152 - interim soultion for B2bAgent to restrict checkout of marketplaceitem */
    if (fromB2bAgentMarketPlace && isB2BAgentMarketPlaceItemPresent) {
        return renderMessage('B2B_AGENT_MKT');
    }
    return null;
};

OOSDiscontinuedMessage.propTypes = {
    discontinuedOOSMessage: exact({
        BODY: string,
        TITLE: string,
    }),
    notAvailableProducts: arrayOf(object),
    enableOOSDiscontinuedMessageWithItemHyperLink: bool,
};

OOSDiscontinuedMessage.defaultProps = {
    discontinuedOOSMessage: {
        BODY: '',
        TITLE: '',
    },
    b2bAgentMarketPlaceItemMessage: {
        BODY: '',
        TITLE: '',
    },
    notAvailableProducts: [],
    enableOOSDiscontinuedMessageWithItemHyperLink: true,
    fromB2bAgentMarketPlace: false,
    fromOOS: false,
};

const mapStateToProps = (state) => {
    const {
        oosDetails: {
            discontinuedOOSDetails: {
                discontinuedItemProducts = [],
                discontinuedOOSMessage,
                oosItemProducts = [],
            } = { oosItemProducts: [], discontinuedItemProducts: [] },
            b2bAgentMarketPlaceDetails: {
                b2bAgentMarketPlaceItemMessage = {},
                b2bAgentMarketPlaceItemProducts = [],
                isB2BAgentMarketPlaceItem: isB2BAgentMarketPlaceItemPresent,
            } = { b2bAgentMarketPlaceItemMessage: {}, b2bAgentMarketPlaceItemProducts: [] },
        },
        context: {
            featureFlags: { enableOOSDiscontinuedMessageWithItemHyperLink = true },
        },
    } = state;

    return {
        discontinuedOOSMessage,
        notAvailableProducts: [...oosItemProducts, ...discontinuedItemProducts],
        enableOOSDiscontinuedMessageWithItemHyperLink,
        b2bAgentMarketPlaceItemMessage,
        b2bAgentMarketPlaceItemProducts,
        isB2BAgentMarketPlaceItemPresent,
    };
};

export default connect(mapStateToProps, null)(OOSDiscontinuedMessage);
